import React from 'react';
import './ProgressDialog.css';

interface ProgressDialogProps {
  visible: boolean;
  message: string;
  progress: number; // 0-100
}

const ProgressDialog: React.FC<ProgressDialogProps> = ({
  visible,
  message,
  progress
}) => {
  if (!visible) return null;

  return (
    <div className="progress-dialog-overlay">
      <div className="progress-dialog">
        <div className="progress-dialog-message">
          {message}
        </div>
        <div className="progress-dialog-bar-container">
          <div className="progress-dialog-bar-background">
            <div 
              className="progress-dialog-bar-fill"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressDialog;
